
export default "/assets/clipboard-mini.2836c57d.svg"